const topics = [
  { icon: 'ri-fire-line', label: '热血冒险', desc: '燃爆你的战斗之魂', color: 'text-red-500', bg: 'bg-red-50' },
  { icon: 'ri-heart-line', label: '恋爱甜宠', desc: '甜蜜到停不下来', color: 'text-pink-500', bg: 'bg-pink-50' },
  { icon: 'ri-search-eye-line', label: '悬疑推理', desc: '烧脑解谜紧张刺激', color: 'text-violet-500', bg: 'bg-violet-50' },
  { icon: 'ri-planet-line', label: '奇幻异世界', desc: '穿越次元的冒险', color: 'text-indigo-500', bg: 'bg-indigo-50' },
  { icon: 'ri-building-line', label: '都市生活', desc: '现实与梦想交织', color: 'text-sky-500', bg: 'bg-sky-50' },
  { icon: 'ri-landscape-line', label: '古风仙侠', desc: '唯美国风江湖梦', color: 'text-emerald-500', bg: 'bg-emerald-50' },
  { icon: 'ri-emotion-laugh-line', label: '搞笑日常', desc: '笑到肚子疼的快乐', color: 'text-amber-500', bg: 'bg-amber-50' },
  { icon: 'ri-ghost-line', label: '恐怖惊悚', desc: '胆小勿入的刺激', color: 'text-slate-500', bg: 'bg-slate-50' },
  { icon: 'ri-rocket-line', label: '科幻未来', desc: '探索未知新世界', color: 'text-cyan-500', bg: 'bg-cyan-50' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-16 md:py-20 bg-background-100 scroll-mt-header">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">专题合集</h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">按题材分类探索你喜欢的漫画，总有一款适合你</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-3 md:gap-5">
          {topics.map((item) => (
            <a
              key={item.label}
              href="#cards"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className={`group flex flex-col items-center gap-3 p-5 md:p-6 rounded-xl ${item.bg} border border-transparent hover:border-background-300/60 transition-all duration-300 cursor-pointer`}
            >
              <div className={`w-12 h-12 md:w-14 md:h-14 rounded-xl flex items-center justify-center bg-background-50 ${item.color} text-2xl`}>
                <i className={item.icon}></i>
              </div>
              <h3 className="font-heading text-base md:text-lg font-bold text-foreground-900">{item.label}</h3>
              <p className="text-xs md:text-sm text-foreground-500 text-center">{item.desc}</p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}